module.exports = __webpack_public_path__ + "img/JieChen.c58d06d3.jpg";